import { Maybe, RosterEntry } from '../data.js';
import { generateId, maybe, num, within } from '../util.js';
import { DesignParts, DesignRosterFields } from './designs.js';
import { StoreProduct } from './stores.js';
import { PublicProduct, WithFeatures } from './products.js';

export const defaultRosterEntry: RosterEntry = Object.freeze({
	id: 'default',
	name: 'NAME',
	number: '00',
	alias: 'ALIAS',
	flag: 'unknown',
});
export const emptyRosterEntry: RosterEntry = Object.freeze({
	id: 'empty',
	name: '',
	number: '',
	alias: '',
	flag: '',
});

export const initRosterEntry = (): RosterEntry => ({
	id: generateId(),
	quantity: 1,
});

export function getDesignRosterFields(product: PublicProduct & WithFeatures, parts: DesignParts, storeProduct?: Maybe<StoreProduct>, allowed: 'allowed' | false = !storeProduct && 'allowed'): DesignRosterFields {

	const features = product.features;
	if (!features) return {};
	
	const { nameNumber: name, flag } = features;
	const sd = storeProduct?.options;
	const arr = Object.values(parts);

	const haveText = (type: string) => arr.some(p => p.type == type && (p.text?.fill || p.text?.stroke));

	return {
		flag: flag && (sd ? (!!sd.allowFlag && 'present') : arr.some(p => p.flag && (p.flag.left != 'off' || p.flag.right != 'off')) ? 'present' : allowed),
		name: name && (sd ? (!!sd.allowName && 'present') : haveText('name') ? 'present' : allowed),
		alias: name && (sd ? (!!sd.allowAlias && 'present') : haveText('alias') ? 'present' : allowed),
		number: name && (sd ? (!!sd.allowNumber && 'present') : haveText('number') ? 'present' : allowed),
	};

}

export function calculateRosterQuantities(initRoster: Maybe<RosterEntry[]>, initQuantity: Maybe<number>, wantRoster = true) {

	if (!wantRoster && !initRoster) return {
		roster: null,
		quantity: initQuantity,
	};

	const roster: RosterEntry[] = initRoster?.map(row => ({
		...row,
		quantity: maybe(row.quantity, q => within(1, Math.floor(num(q)), 10000)) ?? 1,
	})) ?? [{ ...initRosterEntry(), quantity: initQuantity ?? 1 }];

	const quantity = within(1, roster.reduce((a, row) => a + num(row.quantity!), 0), 10000);

	return {
		quantity,
		roster: wantRoster ? roster : null,
	};

}
